<template>
  <form-section :title="$t('Profiles_Overview_Title_LatestViewedProducts')">
    <rest-list
      :payload="fetchEndpoint"
      :border="false"
      :outline="false"
      :filterable="false"
      :pagination="false"
    >
      <rest-list-column prop="imageUrl" title="" :width="100" :sortable="false">
        <template slot-scope="{ row }">
          <img :src="row.imageUrl" class="thumbnail" />
        </template>
      </rest-list-column>
      <rest-list-column prop="name" title="" :sortable="false" />
    </rest-list>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import { projectEndpoint } from '@/core/helpers'
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'

export default {
  name: 'LatestViewedProducts',

  components: {
    RestListColumn,
    RestList,
    FormSection
  },

  data() {
    return {}
  },

  props: {
    profileId: {
      type: String,
      required: true
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `profile/${this.profileId}/latest-products`,
        params: {
          limit: 3
        }
      })
    }
  },

  methods: {}
}
</script>

<style scoped>
>>> th {
  color: #acb0b5;
  font-size: 12px;
  padding-top: 0;
}
.thumbnail {
  width: 60px;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/LatestViewedProducts.vue